var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Организации")]),_c('organizations-search'),_c('h2',[_vm._v("Список организаций")]),_c('organizations-table',{attrs:{"organizations":_vm.organizations}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }